<script>
    import InlineRadio from "../../../components/inline-radio.svelte";
    import Card from "../../components/card.svelte";
    export let errMsg="";
    export let attendanceScheduleError="";
   
    export let attendanceSchedules = [
        { strScheduleTime: "" },
        { strScheduleTime: "" },
    ];    
    export let optionsVM;
   
    $:{ 
        if(optionsVM.importStudents == 0)
        {
            optionsVM.importAttendance = null;
            optionsVM.importGroupsAndClasses= null;
            optionsVM.importContacts = null;
        }
        if(optionsVM.importAttendance == 0)                
        attendanceSchedules = [{ strScheduleTime: "" },{ strScheduleTime: "" }/*,{ strScheduleTime: "" }*/];
 
      //  attendanceSchedules.forEach(schedule => schedule.stringScheduleTime = schedule.strScheduleTime);  
    }

    const clear=(schedule)=>{
        schedule.strScheduleTime="";
        attendanceSchedules=[...attendanceSchedules];
    }
</script>


<Card>
    <div slot="header">
        <h3>Users</h3>
    </div>
    <div slot="body">
        <div class="form-group" >
            <label style="display:block">Import staff?</label>
            <InlineRadio
                name="staff-details"
                options={[{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }]}
                bind:value={optionsVM.importStaff} />
        </div>
        <div class="form-group">
            <label style="display:block;">Import pupils?</label>
            <InlineRadio
                name="student-details"
                options={[{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }]}
                bind:value={optionsVM.importStudents} />
        </div>    
          {#if optionsVM.showContacts}
        <div class="form-group">
            <label
                style="display:block;{!optionsVM.importStudents ? 'color:#6c757d' : ''}">Import pupil contacts?</label>
            <InlineRadio
                name="student-contacts"
                options={[{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }]}
                disabled={!optionsVM.importStudents}
                bind:value={optionsVM.importContacts} />
        </div>
        {/if}
        {#if optionsVM.showGroups}
        <div class="form-group">
            <label
                style="display:block;{!optionsVM.importStudents ? 'color:#6c757d' : ''}">Import pupil groups and classes?</label>
            <InlineRadio
                name="student-classes"
                options={[{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }]}
                disabled={!optionsVM.importStudents}
                bind:value={optionsVM.importGroupsAndClasses} />
        </div>
        {/if}
    </div>
</Card>
{#if optionsVM.showAttendance}
<br />
<Card>
    <div slot="header">   <h3>Attendance</h3></div>
    <div slot="body"> 
      
        <div class="form-group">
            <label
                style="display:block;" class="{!optionsVM.importStudents ? 'labeldisabled' : ''}">Import pupil attendance?</label>
            <InlineRadio
                name="student-attendance"
                options={[{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }]}
                disabled={!optionsVM.importStudents}
                bind:value={optionsVM.importAttendance} />
        </div>
        {#if optionsVM.importAttendance && optionsVM.showAttendanceSchedule}
            <div class="form-group">
                <label for="attendanceSchedule"
                style="display:block;" class="{!optionsVM.importStudents ? 'labeldisabled' : ''}">When should attendance be imported?</label>
                <!-- {#each attendanceSchedules as schedule} -->
                <span>AM:</span>
                    <div style="display:flex;margin-top:5px;">
                        <div style="width:80px;">
                            <input
                                type="time"
                                name="schedule"
                                bind:value={attendanceSchedules[0].strScheduleTime} />
                        </div>
                        {#if attendanceSchedules[0].strScheduleTime != ''}
                            <div>
                                <a
                                    href="javascript:;"
                                    on:click={() => clear(attendanceSchedules[0])}>Clear</a>
                            </div>
                        {/if}
                    </div>
                    <br />
                    <span>PM:</span>
                    <div style="display:flex;margin-top:5px;">
                        <div style="width:80px;">
                            <input
                                type="time"
                                name="schedule"
                                bind:value={attendanceSchedules[1].strScheduleTime} />
                        </div>
                        {#if attendanceSchedules[1].strScheduleTime != ''}
                            <div>
                                <a
                                    href="javascript:;"
                                    on:click={() => clear(attendanceSchedules[1])}>Clear</a>
                            </div>
                        {/if}
                    </div>
                <!-- {/each} -->
                {#if attendanceScheduleError != ''}
                    <span style="color:red">{attendanceScheduleError}</span>
                {/if}
            </div>
        {/if} 
      </div>
</Card>
{/if}
<br />
{#if errMsg != ''}
    <div><span style="color:red">{errMsg}</span></div>
{/if}
